module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="regionsMsg generalLeadBlock">\n	<div class="regionsMsg__img"></div>\n	<div class="regionsMsg__body">\n		<div class="regionsMsg__title">Сложно выбрать тур самому?</div>\n		<div class="regionsMsg__text">Оставьте заказ на сайте и укажите данные вашего путешествия. Менеджер ближайшего офиса подберёт вам тур, который можно будет оплатить на месте. </div>\n	</div>\n	<div class="regionsMsg__btn openGeneralLeadForm"><span>Оставить заявку</span></div>\n</div>';
}
return __p;
};
